module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAO5JREFUKBWdkj0KwkAQhd9oCrGx8g6CRxAEba28jJATBLyMlbUgeAQhd7DRXhnnzbpLfou4kBBm37fz9mWAP5eQ00N+hmKGDHspikfXWZrnc7xxguAlx2I3cpFBCl3hoxcXNEivcY8aNrAVQHYS3FWxbMIJsj1q6IqgW+VHSzCWDet+UISsFq+SQGpqMFB6DVh4pwrEeg10oYegVzXgJyiRyTp2Yo0r3DF8D3rXwGSV9swqH+/ckXYCExSDMHtusSdtv2MLqgTRtxc62kTwH3amx0niQbEzpyeFwzGC3FzQMXKe6HSydY3oc1CKTfEX3MyZq17F/OUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/switcher/illust-x.png
// module id = 4s23
// module chunks = 1